import store from '../store';
import { read_cookie, userCookie } from './cookieHelper';
import {dateElapsed, getCurrentDate} from './calDate';
import FileSaver from 'file-saver';

// 最底層的function =>  receive api data from here。 2020 10 05
function _processRespObj(response) {
    // console.log('api response :')
    // console.log(response)
    // build the docs response
    if (response.docs) {
        response.docs = {
            docs: {},
            autnQS: [],
            ...response.docs
        }
        // console.log(response)
    }

    // else {
    //     //  if we cannot find the values object
    //     if (response.values && !response.values.tagCounts) {
    //         response.values = {
    //             tagCounts: {},
    //             tagValues: {}
    //         }
    //     }
    // }

    return response;
}

export function checkIsDashboard(widgetId) {
    const dashTemplate = store.getState().widget.dashboardTemplate;
    const widgetFound = dashTemplate.reduce((acc, curr) => {
        const isEqual = curr.uid === widgetId;
        if (isEqual) {
            acc.push(curr);
        }
        return acc;
    }, []);

    return widgetFound.length
}


// 在這裡抓取 redux 的 search state
function _buildGlobalParams(widgetId, userToken,params) {
    const dashTemplate = store.getState().widget.dashboardTemplate;
    const searchStore = store.getState().search;

// -------------------------- for authorSearch --------------------------- //
    const isFromAuthorSearch = params ? params.authorKey : false
    const authorSearch = store.getState().authorSearch;
    const allAuthors = store.getState().authorSearch.allAuthors.filter(item => {if(item.GLB_AUTHOR_KEY === params.authorKey){return item}})
    const authorSource = allAuthors.length>0 ? allAuthors[0].GLB_SOURCE :null
    const authorName = allAuthors.length>0 ? encodeURIComponent(allAuthors[0].GLB_AUTHOR) :null
// ----------------------------------------------------------------------- //

    const widgetFound = dashTemplate.reduce((acc, curr) => {
        const isEqual = curr.uid === widgetId;
        if (isEqual) {
            acc.push(curr);
        }
        return acc;
    }, []);

    if (widgetFound.length) {
      console.log('from dashboard：')
      const newSdate =  dateElapsed(widgetFound[0].uiState.sDate, widgetFound[0].uiState.eDate);
      const currentDate =  getCurrentDate(widgetFound[0].uiState.eDate);

      const alldocs = widgetFound[0].uiState.doc ? widgetFound[0].uiState.doc.map(doc => doc.url) : [];
      const blockdocs = widgetFound[0].uiState.docNot ? widgetFound[0].uiState.docNot.map(doc => doc.url) :[];

      return {
        token: userToken,
        sdate: widgetFound[0].uiState.status==='abs'? widgetFound[0].uiState.sDate : newSdate,
        edate: widgetFound[0].uiState.status==='abs'? widgetFound[0].uiState.eDate : currentDate,
        glb_type: widgetFound[0].uiState.glb_type,
        glb_source: widgetFound[0].uiState.source,
        not_glb_source: widgetFound[0].uiState.sourceNot,
        glb_author:widgetFound[0].uiState.author ? widgetFound[0].uiState.author : '',
        not_glb_author: widgetFound[0].uiState.authorNot ? widgetFound[0].uiState.authorNot : '',
        glb_channel_key: widgetFound[0].uiState.chKey,
        not_glb_channel_key:widgetFound[0].uiState.chNotKey,
        glb_posttype: widgetFound[0].uiState.posttype,
        glb_sentiment: widgetFound[0].uiState.sentiment,
        exact: widgetFound[0].uiState.exact ? widgetFound[0].uiState.exact  : '',
        autophrase:widgetFound[0].uiState.autophrase ? widgetFound[0].uiState.autophrase :false,
        alldocs: alldocs.length > 0 ? encodeURIComponent(alldocs.join('+')) : '',
        blockdocs: blockdocs.length > 0 ? encodeURIComponent(blockdocs.join('+')) : '',
      }
    }

    // console.log('from searchPage：')

    const alldocs = searchStore.doc.map( doc => doc.url);
    const blockdocs = searchStore.docNot.map( doc => doc.url);

    // todo 作者查詢需要獨立 globla param fetcher
    // sdate edate glb_author glb_source

    const replaceGlobalParams = params && params.replaceGlobalParams

    return {
      token: userToken,
      sdate: isFromAuthorSearch ? authorSearch.sDate : searchStore.sDate,
      edate: isFromAuthorSearch ? authorSearch.eDate : searchStore.eDate,

      glb_type: replaceGlobalParams ? params.glb_type || '' : searchStore.glb_type.join(),
      glb_source: isFromAuthorSearch ? authorSource : replaceGlobalParams ? params.glb_source : searchStore.source.join(),
      not_glb_source: isFromAuthorSearch ? '' : searchStore.sourceNot.join(),
      glb_author: isFromAuthorSearch ? authorName : searchStore.author.join(),
      not_glb_author: isFromAuthorSearch ? '' : searchStore.authorNot.join(),

      blockdocs: encodeURIComponent(blockdocs.join('+')),
      alldocs: authorSearch.alldocs ? encodeURIComponent(authorSearch.alldocs) : encodeURIComponent(alldocs.join('+')),
      glb_channel_key: isFromAuthorSearch ? '' : searchStore.chKeys.join(),
      not_glb_channel_key: isFromAuthorSearch ? '' : searchStore.chNotKeys.join(),
      autophrase: searchStore.autophrase,
      exact: searchStore.exact
    }
}

function _buildSearchParams(params) {
    const esc = encodeURI;
    const query = Object.keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&');
    return query
}

function _dealMyParams(myParams,isFeatCh3){

    const fieldname = myParams.fieldname
    // TODO => 用更好的方法表示
    // 從 fieldname 比對 myParams，如果不在裡面的 condition => 消除 
    
    const conditionList=['glb_type','glb_source','not_glb_source','glb_channel_key','not_glb_channel_key']

    if(fieldname.indexOf('glb_type') !== -1){
        myParams.glb_source=""
        myParams.glb_channel_key=""
    }
    else if(fieldname.indexOf('glb_source') !== -1){
        myParams.glb_type=""
        myParams.glb_channel_key=""
    }
    else if(fieldname.indexOf('glb_channel_lv1') !== -1){
        if(isFeatCh3){
            myParams.glb_type=""
            myParams.glb_channel_key=""
        }else{
            myParams.glb_type=""
            myParams.glb_source=""
        }
    }

    return myParams
}

export function myFetchOnDrilled(widgetId, noGlobalParams, form, isConditionDrill = false,isFeatCh3,autophrase) {
    const userProfile = read_cookie(userCookie);
    const userToken = userProfile ? userProfile.token : '';

    return (url, params, method, data) => {
        let myParams = noGlobalParams ? { ...params, token: userToken } : _buildGlobalParams(widgetId, userToken);

        myParams = {
            ...myParams,
            ...params,
        };
        // (2020 1106)=>新增 drill 判別 => 可能會有副作用 密切注意
        myParams = isConditionDrill ? _dealMyParams(myParams,isFeatCh3) :myParams
    
        return myFetch(url, myParams, method, data, form)
    }
}

export default function myFetchWithId(widgetId, noGlobalParams, form) {
    const userProfile = read_cookie(userCookie);
    const userToken = userProfile ? userProfile.token : '';

    return (url, params, method, data) => {
        let myParams = noGlobalParams ? { ...params, token: userToken } : _buildGlobalParams(widgetId, userToken, params);
        
        if(params){
            // 刪除不需要傳進後端的判斷值
            params.authorKey === undefined || params.authorKey ? delete params.authorKey : null;
        }

        myParams = {
            ...myParams,
            ...params,
        };

        return myFetch(url, myParams, method, data, form)
    }
}

// todo : new myFetchWithId , can be modify params and global params and extenable


function myFetch(url, params, method, data, form) {
    // console.log('-----------all the search condition-----------------')
    // console.log(url, params, method, data, form)
    // console.log('--------------------------------------------------')

    //  promise race in order to manage timeout options
    return Promise.race([
        new Promise((resolve, reject) => {
            let myurl = url.trim();
            myurl = `${myurl}?${form===true ? '' : _buildSearchParams(params)}`;

            // console.log('now api is :'+myurl)

            const formdata = new FormData();
            for (var prop in params) {
              formdata.append(prop, params[prop])
            };

            fetch(myurl, {
                method: method || "POST",
                body: form===false ? JSON.stringify(data) : formdata,
                mode: "cors",
                headers: form===false ? { "Content-Type": "application/json; charset=utf-8"} : {}
            }).then(response => {
                // response only can be ok in range of 2XX
                if (response.ok) {
                    response.json().then(resp => {
                        // console.log(resp)
                        // sometimes the response is okay, but the json body is not, so we need to have a double check
                        if (resp.response_status === "SUCCESS") {
                            resolve(_processRespObj(resp));
                        } else {
                            reject({
                                code: 500,
                                message: resp.response_message,
                                // open: true,
                            });
                        }

                    }).catch(err => {
                        //  we redirect to the login page, it may be related to token and authentification error
                        reject({
                            code: 500,
                            message: 'An unexpected error has occured',
                            // open: true,
                        });
                    });
                } else {
                    //handle errors in the way you want to
                    switch (response.status) {
                        case 401:
                            console.log('Unauthenticated');
                            reject({
                                code: 401,
                                message: '連線逾時，將導向登入頁面，請重新登入後再進行操作。',
                                open: true,
                            });
                            break;
                        case 403:
                            console.log('Unauthorized');
                            reject({
                                code: 403,
                                message: '連線逾時，將導向登入頁面，請重新登入後再進行操作。',
                                open: true,
                            });
                            break;
                        case 404:
                            console.log('Object not found');
                            reject({
                                code: 404,
                                message: 'Object not found'
                            });
                            break;
                        case 500:
                            console.log('Internal server error');
                            break;
                        case 504:
                            console.log('gate way timeout');
                        default:
                            console.log('Some error occured');
                            break;
                    }
                    //here you also can throw custom error too
                    reject({
                        code: response.status,
                        message: JSON.stringify(response),
                    });
                }
            })
                .catch(error => {
                    //it will be invoked mostly for network errors
                    //do what ever you want to do with error here
                    console.log(error);
                    reject({
                        code: 500,
                        message: error,
                    });
                });
        }),
        new Promise((_, reject) =>
            setTimeout(() => reject({
                code: 408,
                message: 'Request timeout after 2m',
            }), 120000)
        )
    ]);
}


export function exportWithId(widgetId, noGlobalParams, form) {
    const userProfile = read_cookie(userCookie);
    const userToken = userProfile ? userProfile.token : '';
    return (url, params, method, data) => {
        let myParams = noGlobalParams ? { ...params, token: userToken } : _buildGlobalParams(widgetId, userToken, params);
        
        if(params){
            // 刪除不需要傳進後端的判斷值
            params.replaceGlobalParams === undefined || params.replaceGlobalParams ? delete params.replaceGlobalParams : null;
        }
        
        myParams = {
            ...myParams,
            ...params,
        };

        return exportEXCEL(url, myParams, method, data, form)
    }
}

function exportEXCEL(url, params, method, data, form) {
    const utc = new Date().toJSON().slice(0, 10);
  let myurl = url;
  myurl = `${myurl}?${form===true ? '' : _buildSearchParams(params)}`;

  //use formdata when api is form-data
  const formdata = new FormData();
  for (var prop in params) {
    formdata.append(prop, params[prop])
  };

  return new Promise(resolve=>
    fetch(myurl, {
        method: method || "POST",
        body: formdata,
        mode: "cors",
        headers: {}
      })
      .then(response => response.blob())
      .then(blob => FileSaver.saveAs(blob, `${utc}.xlsx`))
      .then(res => resolve('done'))
  )
}



// WEBPACK FOOTER //
// ./src/helpers/myFetch.js